import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaInstagram,
  FaPhone,
  FaPinterest,
  FaTwitter,
} from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
const Footer = () => {
  return (
    <div className="subfooter">
      <div className="container" style={{ marginBottom: "5px" }}>
        {/* <div className="row">
          <div className="col-lg-6 col-6">
            <span style={{ color: "#fff" }}>
              <img
                src="/abasinlogo.png"
                alt=""
                style={{ filter: "brightness(0) invert(1)", height: "40px" }}
              />
            </span>
          </div>
          <div className="col-lg-6 col-6 text-lg-end text-sm-start">
            <img
            src="https://images.emtcontent.com/ukfooterstrips.png"
            style={{ filter: "brightness(0) invert(1)", height: 30 }}
          />

          </div>
        </div> */}
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-sm-6">
            <span style={{ color: "#fff" }}>
              © Copyright FlyAbasin 2024 | All rights reserved
            </span>
          </div>
          <div className="col-lg-6 col-sm-6 text-lg-end text-sm-start">
            <ul className="menu-simple fly_footer_ul_nav">
              <li>
                <Link to="/about-us">About us</Link>
              </li>
              <li>
                <Link to="/terms-conditions">Terms and Conditions</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
